import LZString from 'lz-string';
import { createParser } from 'nuqs';

export function parseAsBase64<T>() {
  return createParser<T>({
    parse: (value: string): T | null => {
      try {
        const decompressed = LZString.decompressFromEncodedURIComponent(value);
        if (!decompressed) return null;
        return JSON.parse(decompressed) as T;
      } catch {
        return null;
      }
    },
    serialize: (value: T): string => {
      try {
        return LZString.compressToEncodedURIComponent(JSON.stringify(value));
      } catch {
        return '';
      }
    },
  });
}
